import React from "react";
import { Stack, Pivot, PivotItem, Breadcrumb } from "office-ui-fabric-react";
import { useHistory, useParams } from "react-router-dom";
import CardHolder from "./CardHolder";
import { ICustomers } from "../../../vm";
import { getAllCustomers } from "../../../services/customers/CustomerService";
import AccessTransaction from "./AccessTransaction";
import EventSources from "./EventSources";
import { ToastContext } from "../../common/ToastProvider";
import { childrenGap8 } from "../../common/Constants";
import LogsConfiguration from "./LogsConfiguration";

export interface AccessLogsMainProps {
  customer: ICustomers;
}

const AccessLogsMain: React.FC<AccessLogsMainProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    customer: {
      name: "",
    },
    selectedKey: "card-holder",
  } as {
    selectedKey: string;
    isLoading: boolean;
    customer: ICustomers;
  });

  //custom hooks
  const history = useHistory();
  const params: any = useParams();
  const { showToast } = React.useContext(ToastContext);

  React.useEffect(() => {
    let hash = window.location.hash;
    if (hash) {
      hash = hash.substr(1);
      setState({
        ...state,
        selectedKey: hash,
      });
    }
  }, [window.location.pathname]);

  React.useEffect(() => {
    const asyncFunc = async () => {
      await getACustomer();
    };
    asyncFunc();
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(
        result.message || "Error while getting customer details",
        "error"
      );
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + "#" + value.props.itemKey);
    // let custId=""
    // history.push(`/customers/${custId}/access-logs/${value}`);
  };

  return (
    <React.Fragment>
      <Stack tokens={childrenGap8}>
        <Stack.Item>
          <Breadcrumb
            items={[
              {
                text: state.customer.name,
                key: "name",
                onClick: () => {
                  history.push(`/customers/${state.customer._id}`);
                },
              },
              { text: "Access Logs", key: "access-logs", isCurrentItem: true },
            ]}
          />
        </Stack.Item>
        <Stack.Item>
          <Pivot
            onLinkClick={handleCallToRouter}
            getTabId={_getTabId}
            selectedKey={state.selectedKey}
          >
            <PivotItem itemKey="card-holder" headerText="Card Holders">
              <CardHolder customerName={state.customer.name} />
            </PivotItem>
            <PivotItem itemKey="transaction" headerText="Access Transactions">
              <AccessTransaction customerName={state.customer.name} />
            </PivotItem>
            <PivotItem itemKey="event-sources" headerText="Event Sources">
              <EventSources />
            </PivotItem>
            <PivotItem itemKey="logs-configuration" headerText="Access Logs Configuration">
              <LogsConfiguration />
            </PivotItem>
          </Pivot>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default AccessLogsMain;
